/*
 * Copyright (c) 2024 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 7/12/2024
 */

import { Dialog, DialogContent } from '@mui/material'
import React from 'react'

const EnlargedImage = ({ open, onClose, image }) => {

    return (
        <Dialog
            maxWidth="lg"
            open={open}
            onClose={onClose}
            aria-labelledby="EnlargedImage"
            aria-describedby="EnlargedImage"
        >
            <DialogContent style={{padding: '5px'}}>
                <img
                    src={`${image}`}
                    alt="EnlargedImage"
                    style={{
                        height: '80vh'
                    }}
                    loading='lazy'
                />
            </DialogContent>
        </Dialog>
    )
}

export default EnlargedImage